import { GetterTree } from 'vuex'
import { PrintedDocumentState } from '@/store/printedDocuments/index'
import { RootState } from '@/store'

export const getters: GetterTree<PrintedDocumentState, RootState> = {
    requestParams(state: PrintedDocumentState): any {
        const params = {
            pagination: true,
            page: state.page,
            itemsPerPage: state.itemsPerPage,
            company: state.companyFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },
}
